import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalsProps {
  showPrivacy: boolean;
  showTerms: boolean;
  onClosePrivacy: () => void;
  onCloseTerms: () => void;
}
export function LegalModals({
  showPrivacy,
  showTerms,
  onClosePrivacy,
  onCloseTerms
}: LegalModalsProps) {
  return <>
      {/* ── POLÍTICA DE PRIVACIDAD ── */}
      <AnimatePresence data-id="element-115">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/85 z-[200] flex items-center justify-center p-5" onClick={onClosePrivacy} data-id="element-116">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-[var(--card)] border border-[var(--border)] rounded-2xl p-7 max-w-[540px] w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-117">
              <h2 className="text-xl font-bold mb-1" data-id="element-118">Política de Privacidad</h2>
              <p className="text-[var(--muted)] text-xs mb-5" data-id="element-119">
                Última actualización: 14 de abril de 2025
              </p>

              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-120">
                Esta Política de Privacidad describe cómo{' '}
                <strong className="text-white" data-id="element-121">Código Rojo</strong> ("nosotros",
                "nuestro") recopila, usa y protege la información personal que
                proporcionas al realizar una compra a través de nuestra tienda
                en línea alojada en Shopify.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-122">
                1. Información que recopilamos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-123">
                Cuando realizas una compra, recopilamos únicamente la
                información necesaria para procesar tu pedido y entregarte el
                producto:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-124">
                <li data-id="element-125">Nombre completo</li>
                <li data-id="element-126">Dirección de correo electrónico</li>
                <li data-id="element-127">Dirección IP (recopilada automáticamente)</li>
                <li data-id="element-128">Información del navegador (recopilada automáticamente)</li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-129">
                <strong className="text-white" data-id="element-130">No recopilamos</strong> datos de
                tarjetas de crédito ni información financiera. Todos los pagos
                son procesados de forma segura por{' '}
                <strong className="text-white" data-id="element-131">Shopify Payments</strong>, que
                cumple con los estándares PCI DSS Nivel 1.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-132">
                2. Cómo usamos tu información
              </h3>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-133">
                <li data-id="element-134">Procesar y confirmar tu compra</li>
                <li data-id="element-135">Enviarte el enlace de descarga del producto digital</li>
                <li data-id="element-136">Comunicarnos contigo en caso de problemas con tu pedido</li>
                <li data-id="element-137">
                  Procesar solicitudes de reembolso dentro del período de
                  garantía
                </li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-138">
                <strong className="text-white" data-id="element-139">
                  No enviamos correos promocionales no solicitados.
                </strong>{' '}
                Tu correo electrónico solo se usa para la entrega del producto y
                comunicaciones directamente relacionadas con tu compra.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-140">
                3. Compartición de datos con terceros
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-141">
                <strong className="text-white" data-id="element-142">
                  No vendemos, alquilamos ni compartimos
                </strong>{' '}
                tu información personal con terceros para fines de marketing.
                Solo compartimos datos con los siguientes proveedores de
                servicios esenciales:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-143">
                <li data-id="element-144">
                  <strong className="text-white" data-id="element-145">Shopify Inc.</strong> —
                  Plataforma de comercio electrónico y procesamiento de pagos
                </li>
                <li data-id="element-146">
                  <strong className="text-white" data-id="element-147">
                    Proveedor de correo electrónico
                  </strong>{' '}
                  — Para la entrega del producto digital
                </li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-148">
                Estos proveedores solo acceden a la información estrictamente
                necesaria para cumplir con su función y están obligados a
                proteger tus datos.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-149">
                4. Retención de datos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-150">
                Conservamos tu información de compra durante el tiempo necesario
                para cumplir con nuestras obligaciones legales y fiscales.
                Puedes solicitar la eliminación de tus datos personales en
                cualquier momento escribiendo a{' '}
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-151">
                  soporte.codigorojo@gmail.com
                </a>
                .
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-152">
                5. Seguridad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-153">
                Utilizamos medidas de seguridad estándar de la industria para
                proteger tu información personal. Nuestra tienda opera sobre la
                infraestructura segura de Shopify con cifrado SSL/TLS en todas
                las transacciones.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-154">
                6. Cookies
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-155">
                Nuestro sitio utiliza cookies esenciales proporcionadas por
                Shopify para el funcionamiento básico de la tienda (carrito de
                compras, sesión). No utilizamos cookies de seguimiento
                publicitario de terceros.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-156">
                7. Tus derechos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-157">
                Dependiendo de tu ubicación, puedes tener derecho a:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-158">
                <li data-id="element-159">Acceder a los datos personales que tenemos sobre ti</li>
                <li data-id="element-160">Solicitar la corrección de datos inexactos</li>
                <li data-id="element-161">Solicitar la eliminación de tus datos personales</li>
                <li data-id="element-162">Oponerte al procesamiento de tus datos</li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-163">
                Si resides en California, tienes derechos adicionales bajo la
                CCPA. Para ejercer cualquiera de estos derechos, contáctanos en{' '}
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-164">
                  soporte.codigorojo@gmail.com
                </a>
                .
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-165">
                8. Menores de edad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-166">
                Nuestro producto está dirigido a personas mayores de 18 años. No
                recopilamos intencionalmente información de menores de edad.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-167">
                9. Cambios a esta política
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-168">
                Nos reservamos el derecho de actualizar esta Política de
                Privacidad en cualquier momento. Los cambios serán publicados en
                esta misma página con la fecha de actualización correspondiente.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-169">
                10. Contacto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-170">
                Si tienes preguntas sobre esta Política de Privacidad o deseas
                ejercer tus derechos, escríbenos a:
                <br data-id="element-171" />
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-172">
                  soporte.codigorojo@gmail.com
                </a>
              </p>

              <button onClick={onClosePrivacy} className="bg-[var(--red)] text-white border-none rounded-lg px-5 py-2.5 font-bold cursor-pointer mt-2 hover:bg-[#a82040] transition-colors" data-id="element-173">
                Cerrar
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* ── TÉRMINOS Y CONDICIONES ── */}
      <AnimatePresence data-id="element-174">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/85 z-[200] flex items-center justify-center p-5" onClick={onCloseTerms} data-id="element-175">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-[var(--card)] border border-[var(--border)] rounded-2xl p-7 max-w-[540px] w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-176">
              <h2 className="text-xl font-bold mb-1" data-id="element-177">Términos y Condiciones</h2>
              <p className="text-[var(--muted)] text-xs mb-5" data-id="element-178">
                Última actualización: 14 de abril de 2025
              </p>

              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-179">
                Al realizar una compra en{' '}
                <strong className="text-white" data-id="element-180">Código Rojo</strong> ("nosotros",
                "nuestro"), aceptas los siguientes Términos y Condiciones. Por
                favor, léelos cuidadosamente antes de completar tu compra.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-181">
                1. Descripción del producto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-182">
                Código Rojo es un{' '}
                <strong className="text-white" data-id="element-183">
                  producto digital descargable
                </strong>{' '}
                de carácter educativo e informativo. Consiste en una guía en
                formato digital que incluye un sistema de evaluación de 20
                puntos, fichas de evaluación, material complementario y bonos
                adicionales. El precio es de{' '}
                <strong className="text-white" data-id="element-184">$17 USD, pago único</strong>. No
                se trata de una suscripción y no se realizarán cargos
                recurrentes.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-185">
                2. Entrega del producto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-186">
                Tras completar el pago exitosamente a través de Shopify
                Payments, recibirás un correo electrónico con el enlace de
                descarga de todos los materiales digitales. La entrega es{' '}
                <strong className="text-white" data-id="element-187">inmediata y automática</strong>.
                Si no recibes el correo dentro de los primeros 15 minutos,
                revisa tu carpeta de spam o escríbenos a{' '}
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-188">
                  soporte.codigorojo@gmail.com
                </a>
                .
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-189">
                3. Licencia de uso
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-190">
                Al adquirir Código Rojo, se te otorga una{' '}
                <strong className="text-white" data-id="element-191">
                  licencia personal, intransferible y no exclusiva
                </strong>{' '}
                para usar el contenido. Esto significa que:
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-192">
                <li data-id="element-193">El contenido es exclusivamente para tu uso personal</li>
                <li data-id="element-194">
                  No puedes reproducir, distribuir, revender ni compartir el
                  material con terceros
                </li>
                <li data-id="element-195">
                  No puedes publicar el contenido en redes sociales, blogs,
                  foros u otros medios públicos
                </li>
                <li data-id="element-196">
                  No puedes crear productos derivados basados en el contenido
                </li>
              </ul>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-197">
                La violación de estos términos resultará en la revocación
                inmediata de tu licencia sin derecho a reembolso.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-198">
                4. Política de reembolso — Garantía de 30 días
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-2" data-id="element-199">
                Ofrecemos una{' '}
                <strong className="text-white" data-id="element-200">
                  garantía de devolución total de 30 días
                </strong>{' '}
                a partir de la fecha de compra. Si no estás satisfecha con el
                producto, puedes solicitar el reembolso completo del 100% de tu
                dinero.
              </p>
              <ul className="text-[var(--muted)] text-sm leading-relaxed mb-4 list-disc pl-5 space-y-1" data-id="element-201">
                <li data-id="element-202">
                  El reembolso se solicita enviando un correo a{' '}
                  <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-203">
                    soporte.codigorojo@gmail.com
                  </a>
                </li>
                <li data-id="element-204">
                  No se requieren formularios complicados ni justificaciones
                </li>
                <li data-id="element-205">
                  El reembolso se procesará a través de Shopify Payments al
                  mismo método de pago original
                </li>
                <li data-id="element-206">
                  El plazo de procesamiento es de 5 a 10 días hábiles
                  dependiendo de tu banco
                </li>
                <li data-id="element-207">
                  Después de los 30 días, no se aceptarán solicitudes de
                  reembolso
                </li>
              </ul>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-208">
                5. Procesamiento de pagos
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-209">
                Todos los pagos son procesados de forma segura a través de{' '}
                <strong className="text-white" data-id="element-210">Shopify Payments</strong>.
                Aceptamos las principales tarjetas de crédito y débito. No
                almacenamos ni tenemos acceso a los datos de tu tarjeta. El
                cargo aparecerá en tu estado de cuenta como una transacción de
                Shopify.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-211">
                6. Propiedad intelectual
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-212">
                Todo el contenido de Código Rojo — incluyendo textos, diseños,
                gráficos, metodologías y materiales complementarios — es
                propiedad exclusiva de Código Rojo y está protegido por las
                leyes de propiedad intelectual de los Estados Unidos. Todos los
                derechos están reservados.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-213">
                7. Limitación de responsabilidad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-214">
                Código Rojo es una herramienta educativa e informativa diseñada
                para apoyar la toma de decisiones personales.{' '}
                <strong className="text-white" data-id="element-215">
                  No constituye asesoría psicológica, terapéutica ni profesional
                  de ningún tipo.
                </strong>{' '}
                Los resultados individuales pueden variar. No nos hacemos
                responsables de las decisiones personales que tomes basándote en
                el contenido del producto.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-216">
                8. Elegibilidad
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-217">
                Para adquirir este producto debes ser mayor de 18 años y tener
                la capacidad legal para realizar transacciones en línea.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-218">
                9. Modificaciones
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-219">
                Nos reservamos el derecho de modificar estos Términos y
                Condiciones en cualquier momento. Los cambios serán publicados
                en esta misma página. El uso continuado del producto después de
                cualquier modificación constituye la aceptación de los nuevos
                términos.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-220">
                10. Ley aplicable
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-221">
                Estos Términos y Condiciones se rigen por las leyes de los
                Estados Unidos de América. Cualquier disputa será resuelta bajo
                la jurisdicción de los tribunales competentes en los Estados
                Unidos.
              </p>

              <h3 className="text-white text-sm font-bold mt-5 mb-2" data-id="element-222">
                11. Contacto
              </h3>
              <p className="text-[var(--muted)] text-sm leading-relaxed mb-4" data-id="element-223">
                Para cualquier pregunta, solicitud de reembolso o consulta
                relacionada con estos términos, escríbenos a:
                <br data-id="element-224" />
                <a href="mailto:soporte.codigorojo@gmail.com" className="text-[var(--red2)] underline" data-id="element-225">
                  soporte.codigorojo@gmail.com
                </a>
              </p>

              <button onClick={onCloseTerms} className="bg-[var(--red)] text-white border-none rounded-lg px-5 py-2.5 font-bold cursor-pointer mt-2 hover:bg-[#a82040] transition-colors" data-id="element-226">
                Cerrar
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}